<template>
  <div class="login">
    <p class="welcome-text">
      欢迎您登录使用本站资源 !
    </p>
    <div class="login-form">
      <el-form status-icon ref="ruleForm" label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="用户名：">
          <el-input type="text" v-model="user" autocomplete="off" placeholder="请输入用户名或邮箱号"></el-input>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input type="password" v-model="pwd" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input v-model.number="code" placeholder="请输入图片中计算结果" style="width: 200px;"
                    @keyup.enter.native="login"></el-input>
          <span class="verification_code" @click="change_code" title="点击更换验证码">
                        <img :src="img_data" v-if="img_data">
                        <i class="el-icon-loading lod_code" v-else></i>
                    </span>
        </el-form-item>
        <el-form-item>
          <span class="btn" @click="login">
                        <i class="el-icon-loading lod" v-if="!status"></i>
                        <i v-else>登录</i>
                    </span>
          <span class="btn" @click="$router.push({path:'/retrieve'})">找回密码</span>
          <span class="btn" @click="$router.push({path:'/register'})">注册</span>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p class="warning-i"><i class="el-icon-warning"></i></p>
      <p style="padding: 10px; text-align: center;color:#000;font-size:16px;font-weight: 600;">
        您的账号当前有用户正在使用, 此账号线程数为: <span style="color:red">{{th_cou}}</span></p>
      <p style="padding: 5px; text-align: center;">最后操作时间: <span style="color:red">{{end_time}}</span></p>
      <p style="padding: 5px; text-align: center;">若无其他人操作，10分钟后可登录</p>
      <p style="padding: 5px; text-align: center;">通知同事点"退出"后可立即登录, 也可<span style="color:#000;font-weight: 600;">申请购买更多并发数</span>避免冲突</p>
      <p style="padding: 5px; text-align: center;">如存在密码泄露,请立即通过邮箱找回密码</p>
      <p style="padding: 20px; text-align: center;">
        <el-button size="small" @click="$router.push({path: '/retrieve'})">找回密码</el-button>
        <el-button size="small" type="primary" @click="dialogVisible=false">确定</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        user: null,
        pwd: null,
        code: null,
        img_data: null,
        img_token: null,
        status: true,
        dialogVisible: false,
        user_count: 0,
        extrude_flag: true,
        end_time: "",
        th_cou: 0
      };
    },
    created() {
      this.requests_code();
      if (localStorage.getItem("loginusername")) {
        this.user = localStorage.getItem("loginusername");
      };
      if (localStorage.getItem("loginpassword")) {
        this.pwd = localStorage.getItem("loginpassword");
      };
    },
    methods: {
      // 请求验证码
      requests_code() {
        this.img_data = null;
        this.img_token = null;
        var d = new Date();
        this.$http.getVerificationCode(d.getTime()).then(response => {
          this.img_data = "data:image/jpeg;base64," + response.data.img;
          this.img_token = response.data.token;
        }).catch(err => {
          this.$message.error('获取验证码失败');
        });
      },

      change_code() {
        this.requests_code()
      },

      // 发起登陆请求事件
      login() {
        // 判断验证码是否获取成功
        if (!this.img_data) {
          return this.$message({
            message: '请获取验证码后再试',
            type: 'warning',
            customClass: 'hint-message',
            center: true
          });
        }
        // 判断用户是否输入信息
        if (!this.user) {
          return this.$message({
            message: '请填写用户名或者邮箱',
            type: 'warning',
            customClass: 'hint-message',
            center: true
          });
        }
        // 判断用户是否输入密码
        if (!this.pwd) {
          return this.$message({
            message: '请填写用户密码',
            type: 'warning',
            customClass: 'hint-message',
            center: true
          });
        }
        // 判断用户是否输入验证码
        if (!this.code) {
          return this.$message({
            message: '请填写验证码',
            type: 'warning',
            customClass: 'hint-message',
            center: true
          });
        }
        // 添加表单元素
        this.status = false;
        let param = new URLSearchParams();
        param.append("login_name", this.user);
        param.append("img_token", this.img_token);
        param.append("code", this.code);
        param.append("pwd", this.pwd);
        localStorage.setItem("loginusername", this.user);
        localStorage.setItem("loginpassword", this.pwd);
        // 请求数据
        this.$http.getLogin(param).then(response => {
          // 响应码为200的时候代码成功
          if (response.code === 200) {
            localStorage.setItem("login_info", response.data.token)
            localStorage.setItem("user_info", this.user)
            sessionStorage.setItem("login_info", response.data.token)
            sessionStorage.setItem("user_info", this.user)
            this.$router.status = true;
            if (response.data.status_day > 30) {
              this.$message({
                message: '登陆成功，欢迎您回来!',
                type: 'success',
                customClass: 'hint-message',
                center: true
              });
              this.$router.push({path: '/main'})
            } else {
              this.$confirm(response.data.status_day>=0?`您的账号VIP还剩余${response.data.status_day}天, 请及时续费!`:'您的账号VIP已到期, 请及时续费!', '提示', {
                confirmButtonText: '续费',
                cancelButtonText: '登录',
                type: 'warning'
              }).then(() => {
                this.$router.push({path: '/pay'})
              }).catch(() => {
                this.$message({
                  message: '登陆成功，欢迎您回来!',
                  type: 'success',
                  customClass: 'hint-message',
                  center: true
                });
                this.$router.push({path: '/main'}) 
              });
            }
            // 其它情况
          } else if (response.code === 1009) {
            this.dialogVisible = true
            this.user_count = response.data
            this.requests_code()
          } else if (response.code === 333) {
            this.$message({
              message: response.msg,
              type: 'error',
              customClass: 'hint-message',
              center: true
            });
            this.requests_code()
          } else if (response.code === 101) {
            this.end_time = response.msg.time,
            this.th_cou = response.msg.enable
            this.dialogVisible = true
            this.requests_code()
          } else {
            this.$message({
              message: response.msg,
              type: 'warning',
              customClass: 'hint-message',
              center: true
            });
            this.requests_code()
          }
          this.status = true;
        }).catch(err => {
          this.$message({
            message: '获取验证码失败',
            type: 'error',
            customClass: 'hint-message',
            center: true
          });
        });
      },
      re_login() {
        let param = new URLSearchParams();
        param.append("login_name", this.user);
        param.append("img_token", this.img_token);
        param.append("code", this.code);
        param.append("pwd", this.pwd);
        param.append("extrude_flag", this.extrude_flag);
        this.$http.getLogin(param).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '登陆成功，欢迎您回来!',
              type: 'success',
              customClass: 'hint-message',
              center: true
            });
            localStorage.setItem("login_info", res.data.token)
            localStorage.setItem("user_info", this.user)
            this.$router.status = true;
            this.status = true;
            setTimeout(()=>{
              this.$router.push({path: '/main'})
            },200)
          } else {
            this.$message({
              message: '未知原因登录失败，请重新尝试',
              type: 'error',
              customClass: 'hint-message',
              center: true
            });
          }
        });
      }
    }
  }
</script>
<style scoped>
  .login {
    width: 1030px;
    margin: 0 auto;
  }

  .welcome-text {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding-top: 5%;
    padding-bottom: 2%;
  }

  .login-form {
    /* background-color: #efefef; */
    padding: 40px 100px 20px 15px;
    border-radius: 10px;
    width: 400px;
    margin: 0 auto;
    text-align: center;
  }

  .btn {
    height: 28px;
    line-height: 28px;
    color: white;
    border: 0;
    background-color: #A7231E;
    font-weight: bold;
    padding: 5px 10px;
    margin: 0 10px;
  }

  .btn:hover {
    cursor: pointer;
    background-color: rgb(207, 50, 44);
  }

  .verification_code {
    display: inline-block;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    width: 90px;
    margin-left: 8px;
    height: 38px;
    background-color: #FAFAFA;
    cursor: pointer;
    vertical-align: top;
  }

  .verification_code img {
    position: relative;
    top: 5px
  }

  .lod {
    display: inline-block;
    width: 28px;
  }
  .warning-i {
    text-align: center;
    color: #e6a23c;
    font-size: 64px;
  }
</style>
